import { Helmet } from "react-helmet-async";

const SEO = ({
    title,
    description,
    image = "/cover.jpg",
    type = "website",
}) => {
    const currentUrl = window.location.href;

    return (
        <Helmet>
            {/* Basic SEO */}
            <title>{title} | Planix</title>

            <meta
                name="description"
                content={description}
            />

            <meta
                name="robots"
                content="index, follow"
            />

            <link
                rel="canonical"
                href={currentUrl}
            />

            {/* Open Graph */}
            <meta property="og:type" content={type} />

            <meta
                property="og:title"
                content={`${title} | Planix`}
            />

            <meta
                property="og:description"
                content={description}
            />

            <meta
                property="og:image"
                content={image}
            />

            <meta
                property="og:url"
                content={currentUrl}
            />

            {/* Twitter */}
            <meta
                name="twitter:card"
                content="summary_large_image"
            />

            <meta
                name="twitter:title"
                content={`${title} | Planix`}
            />

            <meta
                name="twitter:description"
                content={description}
            />

            <meta
                name="twitter:image"
                content={image}
            />

            <script type="application/ld+json">
                {JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Organization",
                    name: "Planix",
                    url: currentUrl,
                    logo: "https://www.planixapp.com/logito92.png",
                    image: image,
                    sameAs: [
                        "https://instagram.com/planix",
                        "https://facebook.com/planix"
                    ],
                    contactPoint: {
                        "@type": "ContactPoint",
                        telephone: "+51983974833",
                        contactType: "customer service",
                        availableLanguage: ["Spanish", "English"]
                    }
                })}
            </script>
        </Helmet>
    );
};

export default SEO;